<div class="workorder-toolbar">
    <div class="container-xl no-print">
        <div class="toolbar">
            <div class="toolbar-content">
                <i class="fa fa-arrow-left" (click)="goBack()" matTooltip="Terug naar werkopdracht" matTooltipPosition="below" style="cursor: pointer;"></i>
                <h1>Werkopdracht afbeeldingen</h1>
            </div>
        </div>
    </div>

    <div class="workorder-images-container">
        <div class="filters-panel no-print">
            <h3>Filters</h3>
            <form [formGroup]="filterForm" class="filter-form">
                <div class="filter-row">
                    <mat-form-field appearance="outline">
                        <mat-label>TVM type</mat-label>
                        <mat-select formControlName="ttmTypeKey" [multiple]="true">
                            @for (type of ttmTypes; track type.key) {
                                <mat-option [value]="type.key">
                                    {{ type.name }}
                                </mat-option>
                            }
                        </mat-select>
                        <mat-hint>Tip: laat dit filter leeg om alle maatregelen te zien</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>TVM status</mat-label>
                        <mat-select formControlName="ttmStatusKey" [multiple]="true">
                            @for (status of ttmStatuses; track status.key) {
                                <mat-option [value]="status.key">
                                    {{ status.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Afbeelding status</mat-label>
                        <mat-select formControlName="imageStatusKey" [multiple]="true">
                            @for (status of ttmStatuses; track status.key) {
                                <mat-option [value]="status.key">
                                    {{ status.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <button mat-raised-button color="warn" type="button" (click)="clearFilters()">
                        Filters wissen
                    </button>
                    <button mat-stroked-button type="button" (click)="printImages()">
                        Afdrukken
                        @if (isPrinting) {
                            <i class="fas fa-spinner fa-spin"></i>
                        }
                    </button>
                </div>
            </form>
        </div>

        <!-- Images Grid -->
        <div class="images-section">
            <div class="images-header no-print">
                <h3>Afbeeldingen ({{ total }})</h3>
            </div>

            @if (loading) {
                <div class="loading-spinner no-print">
                    <mat-spinner></mat-spinner>
                </div>
            }

            @if (!loading && filteredImages.length > 0) {
                <div class="images-grid">
                    @for (image of filteredImages; track image.id) {
                        <div class="image-card page-break">
                            <div class="image-wrapper">
                                <app-codalt-image [url]="'ttm-images/image/' + image.id" [fit]="isPrinting ? 'natural' : 'cover'"></app-codalt-image>
                            </div>
                            <div class="footer">
                                <img class="print-map" [src]="staticMapUrl(image)" alt="Map" />

                                <div class="image-info">
                                    <div class="info-row">
                                        <span class="label">Datum:</span>
                                        <span class="value">{{ image.created_at | date: 'EEEE d MMM yyyy HH:mm' }}</span>
                                    </div>
                                    @if (image.status) {
                                        <div class="info-row">
                                            <span class="label">Status:</span>
                                            <span class="status-badge" [style.background-color]="'#' + image.status.color" [class.dark-text]="image.status.key === 'placed'">
                                                {{ image.status.name }}
                                            </span>
                                        </div>
                                    }
                                    @if (image.ttm) {
                                        <div class="info-row">
                                            <span class="label">Soort:</span>
                                            <span class="value">{{ image.ttm.type?.name }}</span>
                                        </div>
                                        <div class="info-row">
                                            <span class="label">Adres:</span>
                                            <span class="value">
                                                {{ image['address'] }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            @if (!loading && filteredImages.length === 0) {
                <div class="no-images">
                    <p>Geen afbeeldingen gevonden voor deze werkorder.</p>
                </div>
            }
        </div>
    </div>
</div>
